// frontend/src/components/ArtworkPage/ArtworkDisplay.js
import React from "react";
import "./ArtworkDisplay.css";

const ArtworkDisplay = ({ artwork }) => {
  return (
    <div className="artwork-display">
      <div className="artwork-display-container">
        <img
          src={artwork.image}
          alt={artwork.title}
          className="artwork-display-image"
        />
      </div>
    </div>
  );
};

export default ArtworkDisplay;
